module.exports = __webpack_public_path__ + "static/media/visuel08.9b1ace39.jpg";